import {
	TextureLoader,
	SpriteMaterial,
	Sprite,
	Raycaster,
	NearestFilter,
	MirroredRepeatWrapping,
	RepeatWrapping
} from 'three';
import TWEEN from '@tweenjs/tween.js';
import InteractionSurfaceHammer from './InteractionSurfaceHammer';

export default class UIController {
	constructor(scene, canvas, orbitCamera, viewer, contentController) {
		this.VIEWER = viewer;
		this.CAMERA_ORBIT = orbitCamera;
		this.SCENE = scene;
		this.CANVAS = canvas;
		this.CONTENT_CONTROLLER = contentController;
		this.couldBeClick = false;
		this.clickables = [];
		this.cursorPosition = { x: null, y: null };
		this.INTERACTION_SURFACE = new InteractionSurfaceHammer(this, this.CANVAS);

		this.animating = false;
		this.createSprites();

		this.CONTENT_CONTROLLER.loadingCompleted = this.contentLoaded.bind(this);

		this.OVERLAY = document.querySelector('.overlay');
		this.LOGO = document.querySelector('.logo');
		this.CONFIG_BUTTONS = document.querySelectorAll('.options');

		this.config = 0;

		this.CONFIGS = [
			{
				roughnessMap: 'oven_dark_AOoven_Roughnessoven_Metallic.jpg',
				map: 'oven_BaseColor.jpg',
				dialMap: '000.png',
				dialColor: 0x000000
			},
			{
				roughnessMap: 'oven_dark_AOoven_dark_Roughnessoven_dark_Metallic.jpg',
				map: 'oven_dark_BaseColor.jpg',
				dialMap: '255255255.png',
				dialColor: 0xffffff
			}
		];

		this.createEventListeners();
	}

	createEventListeners() {
		for (let i = 0; i < this.CONFIG_BUTTONS.length; i++) {
			const bind = {
				context: this,
				index: i
			};
			this.CONFIG_BUTTONS[i].addEventListener(
				'click',
				this.configClicked.bind(bind)
			);
		}
	}

	configClicked() {
		const self = this.context;
		const config = self.CONFIGS[this.index];

		self.config = this.index;

		for (let i = 0; i < self.CONFIG_BUTTONS.length; i++) {
			const button = self.CONFIG_BUTTONS[i];
			if (i != this.index && button.classList.contains('selected')) {
				button.classList.remove('selected');
			} else if (i == this.index && !button.classList.contains('selected')) {
				button.classList.add('selected');
			}
		}

		self.CONTENT_CONTROLLER.setConfig(config);
	}

	contentLoaded() {
		const self = this;
		// Wait 2 frames before doing anything
		let counter = 2;
		function frameCounter() {
			if (counter > 0) {
				window.requestAnimationFrame(frameCounter);
			} else {
				self.OVERLAY.classList.add('hidden');
				self.LOGO.classList.add('small');
				self.VIEWER.animateIn();
			}
			counter--;
		}
		window.requestAnimationFrame(frameCounter);
	}

	createSprites() {
		const spriteMap = new TextureLoader().load(
			'src/assets/images/arrow-icon.png'
		);
		// spriteMap.magFilter = NearestFilter;
		// spriteMap.minFilter = NearestFilter;
		const spriteMaterial = new SpriteMaterial({
			map: spriteMap,
			color: 0xffffff
		});
		spriteMaterial.map.wrapS = MirroredRepeatWrapping;
		spriteMaterial.map.wrapT = MirroredRepeatWrapping;
		spriteMaterial.map.needsUpdate = true;
		// this.TOP_SPRITE = new Sprite(spriteMaterial);
		// this.TOP_SPRITE.name = 'top_door';
		// this.TOP_SPRITE.animation = 'open';
		// this.TOP_SPRITE.scale.set(0.1, 0.1, 0.1);
		// this.TOP_SPRITE.position.set(0, 1.4, 0.4);
		// this.SCENE.add(this.TOP_SPRITE);
		// this.clickables.push(this.TOP_SPRITE);

		this.BOTTOM_SPRITE = new Sprite(spriteMaterial);
		this.BOTTOM_SPRITE.name = 'bottom_door';
		this.BOTTOM_SPRITE.animation = 'open';
		this.BOTTOM_SPRITE.scale.set(0.1, 0.1, 0.1);
		this.BOTTOM_SPRITE.position.set(0, 0.83, 0.43);
		this.SCENE.add(this.BOTTOM_SPRITE);
		this.clickables.push(this.BOTTOM_SPRITE);
	}

	onInteractionMouseDown(event) {
		this.couldBeClick = true;
	}

	onInteractionMouseMove(event) {
		this.couldBeClick = false;

		const self = this;
		const intersects = this.hitTest(event);
		// if (
		// 	this.lastIntersect != null &&
		// 	(intersects.length == 0 || this.lastIntersect != intersects[0]) &&
		// 	!this.lastIntersect.object.hidden &&
		// 	this.lastIntersect.object.selected
		// ) {
		// 	this.lastIntersect.object.selected = false;
		// 	new TWEEN.Tween(this.lastIntersect.object.material.color)
		// 		.to({ r: 1, g: 1, b: 1 }, 100)
		// 		.start();
		// 	console.log('unSelecting');
		// 	// this.lastIntersect.object.material.color.set(0xffffff);
		// }

		if (
			intersects.length > 0 &&
			this.lastIntersect != intersects[0] &&
			!intersects[0].object.hidden
		) {
			this.lastIntersect = intersects[0];
			if (!this.lastIntersect.object.selected) {
				new TWEEN.Tween(this.lastIntersect.object.material.color)
					.to({ r: 0.733, g: 0.733, b: 0.733 }, 100)
					.start();
				this.CANVAS.classList.add('clickable');
				this.lastIntersect.object.selected = true;
			}
		}

		if (intersects.length == 0 && this.lastIntersect != null) {
			this.lastIntersect.object.selected = false;
			new TWEEN.Tween(this.lastIntersect.object.material.color)
				.to({ r: 1, g: 1, b: 1 }, 100)
				.start();
			this.lastIntersect = null;
			this.CANVAS.classList.remove('clickable');
		}
	}

	// onInteractionMouseUp(event) {
	// 	if (this.couldBeClick && !this.animating) {
	// 		this.interact(event);
	// 	}
	// }

	onInteractionMouseLeave(event) {
		this.couldBeClick = false;
	}

	onInteractionTap(event) {
		this.interact(event);
	}

	onInteractionRotateHorizontal(pixelDeltaX) {
		if (this.interactive === false) {
			return;
		}

		this.CAMERA_ORBIT.rotateHorizontal(pixelDeltaX);
	}

	onInteractionRotateVertical(pixelDeltaY) {
		if (this.interactive === false) {
			return;
		}

		this.CAMERA_ORBIT.rotateVertical(pixelDeltaY);
	}

	onInteractionZoom(delta) {
		if (this.interactive === false) {
			return;
		}

		this.CAMERA_ORBIT.zoom(delta);
	}

	interact(event) {
		const intersects = this.hitTest(event);
		const self = this;
		if (intersects.length > 0) {
			this.CANVAS.classList.remove('clickable');
			this.VIEWER.animate(intersects[0], intersects[0].object.animation);
			const sprite = intersects[0].object;
			const originalScale = {
				x: sprite.scale.x,
				y: sprite.scale.y,
				z: sprite.scale.z
			};
			const scale = {
				x: sprite.scale.x,
				y: sprite.scale.y,
				z: sprite.scale.z
			};
			sprite.hidden = true;
			const hide = new TWEEN.Tween(scale)
				.to({ x: 0.0000001, y: 0.0000001, z: 0.0000001 }, 100)
				.onUpdate(function() {
					sprite.scale.set(scale.x, scale.y, scale.z);
				})
				.onComplete(function(e) {
					// With mirrored repeat on this flips the texture
					if (sprite.material.map.offset.y == 1) {
						sprite.material.map.offset.set(0, 0);
					} else {
						sprite.material.map.offset.set(0, 1);
					}
					const show = new TWEEN.Tween(scale)
						.to({ x: 0.1, y: 0.1, z: 0.1 }, 100)
						.delay(600)
						.onUpdate(function() {
							sprite.scale.set(scale.x, scale.y, scale.z);
						})
						.onComplete(function() {
							sprite.hidden = false;
						})
						.start();
				})
				.start();
		}
	}

	hitTest(event) {
		let position;
		if (event.clientX != undefined) {
			position = { x: event.clientX, y: event.clientY };
		} else if (event.center && event.center.x != undefined) {
			position = { x: event.center.x, y: event.center.y };
		}
		const canvasRect = this.CANVAS.getBoundingClientRect();
		const normalisedPosition = {
			x: ((position.x - canvasRect.left) / this.CANVAS.clientWidth) * 2 - 1,
			y: -((position.y - canvasRect.top) / this.CANVAS.clientHeight) * 2 + 1
		};
		const raycaster = new Raycaster();

		raycaster.setFromCamera(normalisedPosition, this.CAMERA_ORBIT.getCamera());

		const intersects = raycaster.intersectObjects(this.clickables);

		return intersects;
	}

	tick(time) {
		TWEEN.update(time);
	}
}
